import { render, staticRenderFns } from "./StudentTrainingEdit.vue?vue&type=template&id=2fcf889e&scoped=true"
import script from "./StudentTrainingEdit.vue?vue&type=script&lang=js"
export * from "./StudentTrainingEdit.vue?vue&type=script&lang=js"
import style0 from "./StudentTrainingEdit.vue?vue&type=style&index=0&id=2fcf889e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcf889e",
  null
  
)

export default component.exports